import immutable, { Map, Set } from "immutable"

import has from "common/utils/has"
import SearchFormState from "common/records/SearchFormState"
import Place from "common/records/Place"
import { optionsFromPlainJS } from "common/records/Options"
import { TripsDefaultState } from "common/services/trips"
import { getWindowType, getWidth } from "../../../app/scripts/tools/windowBindings"

const Records = {
  trips: TripsDefaultState,
}

export default function(input) {
  const state = {}

  const KEEP_PLAIN = [
    "params",
    "router",
    "currencies",
    "query",
    "translations",
    "staticData",
    "remoteConfig",
    "confirmedForms",
    "resultsView",
    "searchFiltersForm",
    "placesRequests",
    "splitster",
    "sideNav",
    "reservation",
    "topRoutes",
    "simpleLandingPageData",
  ]

  const IGNORE = ["starred"]

  Object.keys(input).forEach(key => {
    if (key === "searchForm" && input.searchForm) {
      state[key] = SearchFormState.fromPlainJS(input[key])
    } else if (IGNORE.includes(key)) {
      state[key] = null
    } else if (KEEP_PLAIN.includes(key)) {
      // do not convert to immutable if it is not changing on client
      state[key] = input[key]
    } else if (key === "places") {
      if (input[key].places) {
        const { places } = input[key]
        let placesMap = Map()
        Object.keys(places).forEach(placeKey => {
          placesMap = placesMap.set(placeKey, Place.fromPlainJS(places[placeKey]))
        })
        state[key] = Map({
          places: placesMap,
          loading: false,
          error: false,
          loadingIds: Set(),
          errorIds: Set(),
        })
      }
    } else if (key === "options") {
      state[key] = optionsFromPlainJS(input[key])
    } else if (has(key, Records)) {
      // $FlowFixMe
      const CustomRecord = Records[key]
      state[key] = new CustomRecord(immutable.fromJS(input[key]))
    } else {
      // by default convert to container/model object
      state[key] = immutable.fromJS(input[key])
    }
    state.window = { type: getWindowType(), width: getWidth() }
    return null
  })
  return state
}
